import type React from "react";
import { PATH_SUPERADMIN } from "src/routesConstants";

import type { Organization } from "src/types/organization";

import { LinkWithIcon } from "./LinkWithIcon";

interface OrganizationLinkProps {
    organization: Organization;
    Icon?: JSX.Element;
    className?: string;
}

export const OrganizationLink: React.FC<OrganizationLinkProps> = ({
    organization,
    Icon,
    className,
}): JSX.Element => (
    <>
        {organization && (
            <LinkWithIcon
                to={`${PATH_SUPERADMIN}/organization/${organization.id}`}
                Icon={Icon}
                className={className}
            >
                {organization.name}
            </LinkWithIcon>
        )}
    </>
);
